import {EventCreationMode} from 'src/modules/event-create/constants';

export type Params = {
    mode: EventCreationMode,
    eventId: number,
    changeRequestId?: number,
};

export const createEventCreationRoutePath = (params: Params) => {
    return `/events/${params.mode}/${params.eventId}/${params?.changeRequestId ? params.changeRequestId : 0}`;
};
